import { APP_CODE_NAME } from '../constants';
export const COMPONENT_NAME = 'App';

export const SET_THEME = `${APP_CODE_NAME}__${COMPONENT_NAME}__SET_THEME`;

export const THEME_1 = 'grey';
export const THEME_2 = 'blue';
export const THEME_3 = 'dark';
export const DEFAULT_THEME = 'DEFAULT_THEME';
export const ALLOWED_THEMES = [THEME_1, THEME_2, THEME_3];

export const TRACK_ID_QUERY_STRING = 'trackid';
export const THEME_QUERY_STRING = 'theme';
export const SHOW_ID_ID_QUERY_STRING = 'showid';
